class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    var summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(e) {
    const nextFocus = e.relatedTarget;
    setTimeout(() => {
      const stillInside = this.contains(document.activeElement);
      const focusMovedInside = nextFocus != null && this.contains(nextFocus);
      if (!stillInside && !focusMovedInside) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    var summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.initHover();
  }

  clearHoverTimeout() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  initHover() {
    if (!this.mainDetailsToggle) return;
    const summary = this.querySelector('summary');
    if (!summary) return;

    const menuLink = summary.querySelector('.ec-header-menu-link');

    const CLOSE_DELAY = 0;
    const PAD = 24;

    const getSafeBox = () => {
      const rects = [summary.getBoundingClientRect()];
      const dropdown = this.querySelector('.ec-fixed-dropdown-wrapper, .ec-mega-wrapper');
      if (dropdown) {
        const d = dropdown.getBoundingClientRect();
        if (d.width > 0 && d.height > 0) rects.push(d);
      }

      let left = Infinity;
      let top = Infinity;
      let right = -Infinity;
      let bottom = -Infinity;
      rects.forEach((r) => {
        left = Math.min(left, r.left);
        top = Math.min(top, r.top);
        right = Math.max(right, r.right);
        bottom = Math.max(bottom, r.bottom);
      });

      return { left: left, top: top - PAD, right: right , bottom: bottom + PAD };
    };

    const pointerInside = (x, y) => {
      const b = getSafeBox();
      return x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
    };

    const scheduleClose = () => {
      this.clearHoverTimeout();
      this.hoverTimeout = setTimeout(() => {
        this.hoverTimeout = null;
        if (this.mainDetailsToggle.hasAttribute('open')) this.close();
      }, CLOSE_DELAY);
    };

    const open = () => {
      this.clearHoverTimeout();
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    };

    summary.addEventListener('mouseenter', open);

    document.addEventListener('mousemove', (e) => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      const stillInside = (e.target && this.contains(e.target)) || pointerInside(e.clientX, e.clientY);
      if (stillInside) {
        this.clearHoverTimeout();
      } else if (!this.hoverTimeout) {
        scheduleClose();
      }
    });

    document.addEventListener('mouseleave', () => {
      if (this.mainDetailsToggle.hasAttribute('open')) scheduleClose();
    });

    if (menuLink) {
      menuLink.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        const href = menuLink.getAttribute('href');
        if (href && href !== '#' && href !== '') {
          window.location.href = href;
        }
        return false;
      });

      summary.addEventListener('click', (e) => {
        if (e.target === menuLink || e.target.closest('.ec-header-menu-link')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }
  }

  onToggle() {
    if (!this.header || !this.mainDetailsToggle) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
